import React from "react";
import ReactTooltip, { Place, Effect } from "react-tooltip";

interface TooltipProps {
  message?: string;
  place?: Place;
  effect?: Effect;
}

function Tooltip({ message, place = "right", effect = "solid" }: TooltipProps) {
  return (
    <>
      {message && (
        <i
          className={"product-section__info"}
          id={"project-title-info"}
          data-tip={message}>
          i
        </i>
      )}
      <ReactTooltip place={place} effect={effect} delayShow={100} />
    </>
  );
}

export default Tooltip;
